/**
 * Event Type Selector — icon button grid for categorizing events
 */

import {
  Trophy,
  Music,
  Tent,
  Mic2,
  PartyPopper,
  Heart,
  Calendar,
} from "lucide-react";
import { cn } from "@/lib/utils";
import type { EventType } from "@/lib/store";

interface EventTypeOption {
  id: EventType;
  name: string;
  icon: React.ReactNode;
}

const EVENT_TYPES: EventTypeOption[] = [
  { id: "sports", name: "Sports", icon: <Trophy className="h-5 w-5" /> },
  { id: "concert", name: "Concert", icon: <Music className="h-5 w-5" /> },
  { id: "festival", name: "Festival", icon: <Tent className="h-5 w-5" /> },
  { id: "conference", name: "Conference", icon: <Mic2 className="h-5 w-5" /> },
  { id: "party", name: "Party", icon: <PartyPopper className="h-5 w-5" /> },
  { id: "wedding", name: "Wedding", icon: <Heart className="h-5 w-5" /> },
  { id: "general", name: "General", icon: <Calendar className="h-5 w-5" /> },
];

interface EventTypeSelectorProps {
  value: EventType;
  onChange: (value: EventType) => void;
}

export function EventTypeSelector({ value, onChange }: EventTypeSelectorProps) {
  return (
    <div>
      <label className="block text-sm font-medium text-vizimix-200 mb-2">
        Event Type
      </label>
      <div className="grid grid-cols-4 gap-2">
        {EVENT_TYPES.map((type) => (
          <button
            key={type.id}
            type="button"
            onClick={() => onChange(type.id)}
            className={cn(
              "flex flex-col items-center rounded-lg border-2 px-2 py-3 text-center transition-all",
              value === type.id
                ? "border-vizimix-500 bg-vizimix-500/20"
                : "border-organize-border hover:border-vizimix-600"
            )}
          >
            <div className="mb-1.5 text-vizimix-400">{type.icon}</div>
            <div className="text-xs font-medium text-vizimix-200">
              {type.name}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
